import api from '../lib/api';

// Types
export interface DocumentCollection {
  uuid: string;
  name?: string;
  cmetadata?: Record<string, any>;
}

export interface CreateDocumentCollectionDto {
  name?: string;
  projectId: number;
  cmetadata?: Record<string, any>;
}

export interface UpdateDocumentCollectionDto {
  name?: string;
  cmetadata?: Record<string, any>;
}

// API Response types
export interface ApiResponse<T> {
  status: 'success' | 'error';
  data?: T;
  message?: string;
  code?: number;
}

export interface GetDocumentCollectionsResponse extends ApiResponse<DocumentCollection[]> {}
export interface GetDocumentCollectionResponse extends ApiResponse<DocumentCollection> {}
export interface CreateDocumentCollectionResponse extends ApiResponse<DocumentCollection> {}
export interface UpdateDocumentCollectionResponse extends ApiResponse<DocumentCollection> {}
export interface DeleteDocumentCollectionResponse extends ApiResponse<null> {}

export interface PaginationParams {
  page?: number;
  limit?: number;
  projectId?: number;
}

class DocumentCollectionsService {
  private readonly baseUrl = '/api/document-collections';

  async getDocumentCollections(params?: PaginationParams): Promise<GetDocumentCollectionsResponse> {
    const response = await api.get<GetDocumentCollectionsResponse>(this.baseUrl, {
      params: {
        page: params?.page || 1,
        limit: params?.limit || 10,
        ...(params?.projectId && { projectId: params.projectId })
      }
    });
    return response.data;
  }

  async getDocumentCollection(id: string, projectId: number): Promise<GetDocumentCollectionResponse> {
    const response = await api.get<GetDocumentCollectionResponse>(`${this.baseUrl}/${id}`, {
      params: { projectId }
    });
    return response.data;
  }

  async createDocumentCollection(data: CreateDocumentCollectionDto): Promise<CreateDocumentCollectionResponse> {
    const response = await api.post<CreateDocumentCollectionResponse>(this.baseUrl, data);
    return response.data;
  }

  async updateDocumentCollection(id: string, data: UpdateDocumentCollectionDto, projectId: number): Promise<UpdateDocumentCollectionResponse> {
    const response = await api.put<UpdateDocumentCollectionResponse>(`${this.baseUrl}/${id}`, data, {
      params: { projectId }
    });
    return response.data;
  }

  async deleteDocumentCollection(id: string, projectId: number): Promise<DeleteDocumentCollectionResponse> {
    const response = await api.delete<DeleteDocumentCollectionResponse>(`${this.baseUrl}/${id}`, {
      params: { projectId }
    });
    return response.data;
  }
}

export default new DocumentCollectionsService();